import React, { useState } from 'react';
import { postData } from '../global/Globalapi';
import { FaStar } from 'react-icons/fa'; // Import star icon
import { showAlert } from './DynamicComp/Alert';
import { IoImageOutline, IoVideocamOutline } from 'react-icons/io5'; // Icons for image/video upload

const Reviews = ({ product_id }) => {
  const [formData, setFormData] = useState({
    comment: '',
    rating: 0,
    reviewTitle: '', // New: For review title
    publicName: '',  // New: For public name
  });

  const [imageFile, setImageFile] = useState(null); // New: State for image file
  const [videoFile, setVideoFile] = useState(null); // New: State for video file
  const [imagePreview, setImagePreview] = useState(null); // New: State for image preview
  const [videoPreview, setVideoPreview] = useState(null); // New: State for video preview

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleRatingChange = (newRating) => {
    setFormData((prev) => ({
      ...prev,
      rating: newRating,
    }));
  };

  const handleFileChange = (e, fileType) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        if (fileType === 'image') {
          setImageFile(file);
          setImagePreview(reader.result);
          setVideoFile(null); // Clear video if image is selected
          setVideoPreview(null);
        } else if (fileType === 'video') {
          setVideoFile(file);
          setVideoPreview(reader.result);
          setImageFile(null); // Clear image if video is selected
          setImagePreview(null);
        }
      };
      reader.readAsDataURL(file);
    } else {
      if (fileType === 'image') {
        setImageFile(null);
        setImagePreview(null);
      } else if (fileType === 'video') {
        setVideoFile(null);
        setVideoPreview(null);
      }
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const userString = localStorage.getItem("user");
    const user = userString ? JSON.parse(userString) : null;
    const user_id = user?.id;
    const username = user?.name; // This might be overridden by publicName

    if (!user_id) {
      showAlert({ type: 'warning', message: "Please log in to submit a review.", title: 'Warning' });
      return;
    }
    if (formData.rating === 0) {
      showAlert({ type: 'warning', message: "Please provide a star rating.", title: 'Warning' });
      return;
    }
    if (!formData.comment.trim()) {
      showAlert({ type: 'warning', message: "Please enter a comment.", title: 'Warning' });
      return;
    }
    if (!formData.reviewTitle.trim()) { // New validation
      showAlert({ type: 'warning', message: "Please enter a review title.", title: 'Warning' });
      return;
    }
    if (!formData.publicName.trim()) { // New validation
      showAlert({ type: 'warning', message: "Please enter your public name.", title: 'Warning' });
      return;
    }

    try {
      const checkRes = await postData("/check-review", { user_id, product_id });

      if (!checkRes.data.decision) {
        showAlert({ type: 'warning', message: "You are not allowed to review this product!", title: 'Warning' });
        return;
      }

      // Create FormData to handle file uploads
      const reviewFormData = new FormData();
      reviewFormData.append('product_id', product_id);
      reviewFormData.append('user_id', user_id);
      reviewFormData.append('username', formData.publicName); // This will be stored as customer_name in DB
      reviewFormData.append('comment', formData.comment);
      reviewFormData.append('rating', formData.rating);
      reviewFormData.append('review_title', formData.reviewTitle); // Review Title

      // if (imageFile) {
      //   reviewFormData.append('media_file', imageFile); // File upload field
      // } else if (videoFile) {
      //   reviewFormData.append('media_file', videoFile); // File upload field
      // }

      const addRes = await postData("/add-review", reviewFormData); // Use reviewFormData here!
      showAlert({ type: 'success', message: addRes.data.message, title: 'Success' });

      // Clear the form after successful submission
      setFormData({
        comment: '',
        rating: 0,
        reviewTitle: '',
        publicName: '',
      });
      setImageFile(null);
      setVideoFile(null);
      setImagePreview(null);
      setVideoPreview(null);

    } catch (error) {
      console.error("Review submission error:", error);
      showAlert({ type: 'error', message: "An error occurred while submitting your review.", title: 'Error' });
    }
  };

  return (
    <div className='max-w-xl mx-auto p-6 bg-white rounded-lg shadow-md'>
      <h2 className='text-2xl font-semibold text-gray-800 mb-4'>Leave a Review</h2>
      <form onSubmit={handleSubmit}>
        {/* Product Name (from image) */}
        <p className="text-gray-600 mb-4">Amazon Basics Capactive Stylus Pen for iOS ...</p>
        
        {/* Rating Section with Stars */}
        <div className='mb-4'>
          <label className='block text-lg font-medium text-gray-700 mb-2'>How was the item?</label>
          <div className='flex items-center space-x-1'>
            {[...Array(5)].map((_, index) => {
              const ratingValue = index + 1;
              return (
                <FaStar
                  key={ratingValue}
                  className={`cursor-pointer ${
                    ratingValue <= formData.rating ? 'text-yellow-400' : 'text-gray-300'
                  }`}
                  size={24}
                  onClick={() => handleRatingChange(ratingValue)}
                />
              );
            })}
          </div>
        </div>

        {/* Comment Text Area */}
        <div className='mb-4'>
          <label className='block text-lg font-medium text-gray-700 mb-2'>Write a review</label>
          <textarea
            name="comment"
            value={formData.comment}
            onChange={handleChange}
            placeholder="What should other customers know?"
            className='w-full h-32 p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            required
          />
        </div>

        {/* Share a video or photo section */}
        <div className='mb-6'>
          <label className='block text-lg font-medium text-gray-700 mb-2'>Share a video or photo</label>
          <div className='flex items-center justify-center p-4 border-2 border-dashed border-gray-300 rounded-md cursor-pointer hover:border-blue-400 transition-all duration-200'>
            <input
              type="file"
              accept="image/*,video/*" // Allow both image and video
              onChange={(e) => handleFileChange(e, e.target.files[0]?.type.startsWith('image') ? 'image' : 'video')}
              className="hidden"
              id="media-upload"
            />
            <label htmlFor="media-upload" className="flex flex-col items-center justify-center w-full h-full cursor-pointer text-gray-500">
              {imagePreview ? (
                <img src={imagePreview} alt="Preview" className="max-h-24 object-contain mb-2" />
              ) : videoPreview ? (
                <video src={videoPreview} controls className="max-h-24 object-contain mb-2" />
              ) : (
                <>
                  <IoImageOutline size={30} className="mb-1" />
                  <IoVideocamOutline size={30} className="mb-1" />
                  <span>Click to upload image or video</span>
                </>
              )}
              {(imageFile || videoFile) && (
                <span className="text-xs text-gray-600 mt-1">{imageFile?.name || videoFile?.name}</span>
              )}
            </label>
          </div>
        </div>

        {/* Title your review (required) */}
        <div className='mb-4'>
          <label className='block text-lg font-medium text-gray-700 mb-2'>Title your review <span className="text-red-500">(required)</span></label>
          <input
            type="text"
            name="reviewTitle"
            value={formData.reviewTitle}
            onChange={handleChange}
            placeholder="What's most important to know?"
            className='w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            required
          />
        </div>

        {/* What's your public name? (required) */}
        <div className='mb-6'>
          <label className='block text-lg font-medium text-gray-700 mb-2'>What's your public name? <span className="text-red-500">(required)</span></label>
          <input
            type="text"
            name="publicName"
            value={formData.publicName}
            onChange={handleChange}
            placeholder="" // Example name from screenshot
            className='w-full p-3 border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-blue-500'
            required
          />
        </div>

        <button
          type="submit"
          className='w-full bg-orange-500 text-white font-bold py-3 px-4 rounded-md hover:bg-orange-600 transition'
        >
          Submit
        </button>
      </form>
    </div>
  );
};

export default Reviews;